import styled from "styled-components";
import {FormControl} from "@mui/material";

export const StyledFormControl = styled(FormControl)`
  
  &&{
    width: 250px;
    height: 65px;
    margin: 0;
  }
  
`;
